import ResourceApi from '../ResourceApi';

const UserSkillResource = {
  index: async (userId, params = {}) => (await ResourceApi.get(`/resource/users/${userId}/skills`, params)).data,
  post: async (userId, skillId) => (await ResourceApi.post(`/resource/users/${userId}/skills`, { skill_id: skillId })).data,
  destroy: async (userId, userSkillId) => (await ResourceApi.destroy(`/resource/users/${userId}/skills/${userSkillId}`)).data,
};

export default UserSkillResource;
